module.exports = __webpack_public_path__ + "static/img/valparaiso-crew-lyvia.8852490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crew/valparaiso-crew-lyvia.jpg
// module id = 236
// module chunks = 0